export default __webpack_public_path__ + "static/media/33.4cf3f4a3.jpeg";